<template>
  <div class="home">
    <a-layout>
      <!-- header -->
      <a-layout-header>
        <a-row type="flex" justify="space-between" align="middle" class="header-nav" :class="isFixed ? 'isFixed' : ''">
          <a-col :xs="24" :sm="6">
            <div class="nav-left"></div>
          </a-col>
          <a-col :xs="24" :sm="12">
            <div class="nav-center">
              <div class="title"><a href="https://egger.vigour.net.cn" target="_blank">EGGER/爱格</a></div>
              <div class="title"><router-link target="_blank" to="/main">CLEAF/可丽芙</router-link></div>
              <!--  <div class="title"><router-link target="_blank" to="/main/about">VIGOUR/惟嘉</router-link></div> -->
            </div>
          </a-col>
          <a-col :xs="24" :sm="6">
            <div class="nav-right">
              <div class="img"></div>
              <div class="number">
                <div class="title">全国客服热线：</div>
                <div class="telphone">400&nbsp;821&nbsp;5227</div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-layout-header>
      <!-- 底层 -->
      <div class="header-under" :class="isFixed ? 'isFixed' : ''"></div>
      <!-- content -->
      <a-layout-content>
        <!-- 走马灯 -->
        <a-row>
          <a-col :xs="0" :sm="24">
            <a-carousel effect="fade" autoplay>
              <div v-for="item in advList" :key="item.id">
                <!-- 判断是否有图片外链 -->
                <!-- 有链接 -->
                <a :href="item.advertisingUrl" target="_blank" v-if="item.advertisingUrl">
                  <img :src="imgUrl + item.advertisingImg" />
                </a>
                <!-- 无连接仅显示图片 -->
                <img :src="imgUrl + item.advertisingImg" v-else />
              </div>
            </a-carousel>
          </a-col>
        </a-row>
        <!-- 品牌介绍 -->
        <a-row class="brand" type="flex">
          <a-col :xs="24" :sm="12">
            <div class="group group_left">
              <div class="logo logo_egger"></div>
              <div class="banner brand_egger"></div>
              <div class="title">
                <a href="http://egger.vigour.net.cn" target="_blank">
                  <span class="name" style="background-color: #d9012a">EGGER/爱格</span>
                </a>
              </div>
              <p class="desc">
                爱格集团创立于1961年，是一家稳步发展的家族企业，公司总部位于奥地利提罗尔州圣约翰。作为全方位的木质基础板材与锯材制造商，爱格始终坚信“更多创造，源自木材”。
              </p>
              <p class="desc">
                目前，爱格已在全球11个国家建立了22家工厂，完整的爱格产品系列满足了家具、室内设计、木建筑和地板等各个领域的需求。
              </p>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12">
            <div class="group group_right">
              <div class="logo logo_cleaf"></div>
              <div class="banner brand_cleaf"></div>
              <div class="title">
                <a href="http://cleaf.vigour.net.cn" target="_blank">
                  <span class="name" style="background-color: #000000">CLEAF/可丽芙</span>
                </a>
              </div>
              <p class="desc">CLEAF是一家意大利公司，为家具和室内设计行业生产创新表面和解决方案。</p>
              <p class="desc">
                在BRIANZA工厂定制生产的饰面板，防火板和封边条，由建筑师和家具公司在世界各地安装，为生活和工作营造创意空间。
              </p>
            </div>
          </a-col>
        </a-row>
        <a-row class="bottom">
          <a-col :span="24">
            <span class="title">中国华东区代理商</span>
          </a-col>
        </a-row>
      </a-layout-content>
      <site-footer variant="light">
        <template #right>
            <p>
              上海惟嘉经贸有限公司 版权所有<br />
              地址：上海徐汇·宜山路407号-1尚光徐汇中心金座903室<br />
              电话：86-21-64692449<br />
              客服热线：400-821-5227（工作日9:00-17:30）<br />
              邮编：200030<br />
              邮件地址：info@vigour.net.cn<br /><br />
              <a href="https://beian.miit.gov.cn/" target="_blank">
                <span style="color: #535353">沪ICP备14004273号-1</span>
              </a>
            </p>
        </template>
        <template #bottom>
          <div class="footer-line"></div>
        </template>
      </site-footer>
    </a-layout>
  </div>
</template>

<script>
// @ is an alias to /src
import SiteFooter from '@/components/SiteFooter.vue'
import { geAdvertisingList } from '@/api'
export default {
  name: 'Home',
  components: { SiteFooter },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      isFixed: false,
      advList: [],
    }
  },
  created() {
    this.getadvData()
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    getadvData() {
      geAdvertisingList({ type: '1' }).then((res) => {
        if (res.success) {
          this.advList = res.result
        }
      })
    },
    onScroll() {
      const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      console.log('>>>>scroll', scroll)
      if (scroll > 0) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.home
  .ant-layout
    position relative
    .ant-layout-header
      position fixed
      top 0
      left 0
      width 100%
      background-color #fff
      line-height 1
      height auto
      z-index 100
      .header-nav
        max-width 1320px
        margin 0 auto
        height 140px
        transition height 0.3s ease
        &.isFixed
          height 90px
        .nav-left, .nav-right, .nav-center
          height 50px
        .nav-left
          background-image url('~@/assets/images/home_logo.png')
          background-position 0 0
          background-repeat no-repeat
          background-size contain
        .nav-center
          line-height 50px
          text-align center
          .title
            display inline-block
            padding 0 35px
            border-right 1px solid #000
            font-size 24px
            line-height 24px
            vertical-align bottom
            a, a:hover
              color #000000
            &:first-child
              padding-left 0
            &:last-child
              padding-right 0
              border-right 0
        .nav-right
          text-align right
          @media screen and (max-width 600px)
            text-align center
          .img, .number
            display inline-block
          .img
            width 38px
            height 39px
            margin 5px 5px 0 0
            opacity 0.5
            background-image url('~@/assets/images/home_phone.png')
            background-repeat no-repeat
          .number
            .title
              font-size 18px
              font-style italic
              font-stretch normal
              color #000
              opacity 0.5
              text-align left
              margin-bottom 8px
            .telphone
              font-size 24px
              font-weight bold
              font-style italic
              font-stretch normal
              color #e60012
    .header-under
      height 140px
      width 100%
      background-color #fff
      transition height 0.3s ease
      &.isFixed
        height 90px
    .ant-layout-content
      background-color #fff
      .ant-carousel
        margin-bottom 67px
        & >>> .slick-slide
          text-align center
          // max-height 750px
          overflow hidden
        & >>> .slick-slide img
          display inline-block
          width 100%
          text-align center
          color #fff
      .brand
        max-width 1320px
        display inline-block
        text-align center
        .group_left
          padding 0 40px 0 0
        .group_right
          padding 0 0 0 40px
        .group
          margin-bottom 85px
          @media screen and (max-width 600px)
            padding 0 15px
            margin-bottom 25px
          .logo
            height 45px
            margin-bottom 50px
            background-position center
            background-repeat no-repeat
          .logo_egger
            background-image url('~@/assets/images/logo_egger.jpg')
          .logo_cleaf
            background-image url('~@/assets/images/logo_cleaf.jpg')
          .banner
            height 300px
            margin-bottom 32px
            background-position center
            background-repeat no-repeat
            background-size cover
          .brand_egger
            background-image url('~@/assets/images/brand_egger1.jpg')
          .brand_cleaf
            background-image url('~@/assets/images/brand_cleaf1.jpg')
          .title
            line-height 35px
            margin-bottom 34px
            .name
              display inline-block
              padding 7px 30px
              border-radius 30px
              font-size 21px
              color #ffffff
          .desc
            color #535353
            text-indent 2em
            text-align left
            line-height 2
            margin 0
            @media screen and (max-width 600px)
              padding 0 15px
      .bottom
        .title
          font-size 60px
          font-style italic
          font-stretch normal
          opacity 0.15
          line-height 60px
          @media screen and (max-width 600px)
            font-size 50px
            line-height 50px
    .ant-layout-footer
      background-color #d9d9d9
      padding 0
      .footer
        max-width 1320px
        margin 0 auto
        text-align left
        .left
          .qrcode
            display inline-block
            text-align center
            margin-right 24px
            &:last-child
              margin-right 0
            .title
              margin-top 16px
              display block
              font-size 14px
              color #000000
        .right
          line-height 1.5
          p
            display inline-block
            font-size 16px
            margin 20px 0
      .footer-line
        height 20px
        width 100%
        background-color #575757
</style>
